import { oz } from '@vy/utils';

export const SIZES = Object.freeze({
  XXS: 'xxs',
  XS: 'xs',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  XL: 'xl',
  XXL: 'xxl',
});

export const SIZES_SCHEMA = oz.nativeEnum(SIZES);

export type Size = oz.infer<typeof SIZES_SCHEMA>;
